import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { MyleTabKey } from "@/Common/Models/MyleMenu/enums/MyleTabKey";
import { CommunicationsCounters } from "@/Common/Models/MyleMenu/Tooltip/CommunicationsCounters";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { Counters } from "@/Communications/Api/Dto/Responses/Counters";
import { CommunicationsStore } from "@/Communications/Stores/CommunicationsStore";

class CommunicationsResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.Myle_CountCommunication, this.CountCommunication);
    }

    private CountCommunication(response: ServerEvent, store: CommunicationsStore): void {
        const countersResponse: Counters = response.Data;
        store.CommunicationsCountersModel = Immutable.fromJS(countersResponse);
        store.EmitChangeToListeners();

        // update top menu
        const topCounter = store.CommunicationsCountersModel.get("UnreadMessagesCount") + store.CommunicationsCountersModel.get("UnreadTasksCount") + (store.CommunicationsCountersModel.get("UnreadExternalMessagesCount"));
        let bottomCounter = store.CommunicationsCountersModel.get("PastDueTasksCount");

        const unreadMessagesCount = store.CommunicationsCountersModel.get("UnreadMessagesCount");
        const unreadTasksCount = store.CommunicationsCountersModel.get("UnreadTasksCount");
        const unreadExternalMessagesCount = store.CommunicationsCountersModel.get("UnreadExternalMessagesCount");
        const pastDueTasksCount = store.CommunicationsCountersModel.get("PastDueTasksCount");

        const communicationsCounters = new CommunicationsCounters(
            unreadMessagesCount,
            unreadTasksCount,
            unreadExternalMessagesCount,
            pastDueTasksCount
        );

        // only count recalls if current user is not a clinician
        if (sessionStore.getCurrentEmployee().Type !== EmployeeType.Practician)
            bottomCounter += store.CommunicationsCountersModel.get("RecallsCount");

        cacheStore.UpdateTab(
            MyleTabKey.Communications,
            topCounter,
            bottomCounter,
            null,
            null,
            false,
            { communicationsCounters: communicationsCounters }
        );
    }
}

export { CommunicationsResponseHandler };
